import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Content, SubContent, Main } from "../../../components/Layout";
import style from "../style.module.css";
import MenuTrainee from "../../../components/MenuTrainee";
import api from "../../../services/api";
import useWrapper from "../../../hooks/useWrapper";
import FileDisplay from "../../../components/FileDisplay";

export default function TraineeArea() {
  const { me, config } = useWrapper();

  const [reload, setreload] = useState();
  const [files, setfiles] = useState([]);
  const [loading, setloading] = useState();
  useEffect(() => {
    (async function () {
      setloading(true);
      const { data } = await api.get(`trainee/commercial/${me.commercial_id}`, config);
      let _files = data.files.filter(__file => me.is_member || __file.publico === "publico");
      setfiles(_files);
      setloading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `config` is a new object every WrapperProvider render (src/context/WrapperContext.jsx); adding it would refire this fetch on unrelated context updates.
  }, [reload, me.commercial_id, me.is_member]);

  return (
    <Main className={style.mainUser}>
      <Content noBG="true">
        <Row>
          <Col md={12} lg={2}>
            <MenuTrainee />
          </Col>
          <Col>
            <SubContent>
              <FileDisplay
                files={files || []}
                commercial_id={me?.commercial_id}
                reload={() => {
                  setreload(!reload);
                }}
                loading={loading}
              />
            </SubContent>
          </Col>
        </Row>
        <Row></Row>
      </Content>
    </Main>
  );
}
